module.exports = __webpack_public_path__ + "img/jjh.10869657.png";